import 'utils/Polyfills';
import React from 'react';
import { createRoot } from 'react-dom/client';
import {Provider} from 'react-redux';
import configureStore from 'stores/mobile.homePageStore';
import ProductSearchStep from 'productSearch/ProductSearchStep';
import {initProductSearchStateFromServer} from 'productSearch/productSearchActions';

const store = configureStore();
const root = createRoot(document.getElementById('productSearch'));

root.render(
  <Provider store={store}>
    <ProductSearchStep />
  </Provider>
);

//dispatch
let action = initProductSearchStateFromServer(productSearchServerState);
store.dispatch(action);
